<template>
    <el-dialog title="거래처 검색" v-model="dialogVisible"   :width="dialogWidth"     @close="handleClose">
      <el-button type="primary"  @click="openSupplierAddModal" class="full-width-button">거래처추가</el-button>        

      <el-input
        v-model="searchQuery"
        placeholder="거래처 이름을 입력하세요"
        @input="filterSuppliers"
      />
  
      <el-table :data="filteredSuppliers || []" style="width:  100%" :class="{ 'mobile-table': isMobile }">
        <el-table-column prop="name" label="거래처 이름" />
        <el-table-column prop="business_number" label="사업자등록번호" />

        <el-table-column label="계좌 선택">
        <template #default="{ row }">
          <el-button type="primary"   class="full-width-button" @click.stop="showAccounts(row)">
            계좌 보기
          </el-button>
        </template>
      </el-table-column>      
      </el-table>

      <template #footer>
        <el-button @click="$emit('close')">닫기</el-button>
      </template>
    </el-dialog>


        <!-- 계좌 정보 모달 -->
     <el-dialog v-model="accountDialogVisible" title="계좌 정보" width="50%">
      <el-table :data="selectedSupplierAccounts || []" style="width: 100%">
        <el-table-column prop="bank_name" label="은행명" />
        <el-table-column prop="account_number" label="계좌번호" />
        <el-table-column prop="account_holder" label="예금주" />
        <el-table-column prop="swift_code" label="SWIFT_코드" />
        <el-table-column prop="account_type" label="계좌 종류" />
        <el-table-column label="선택">
          <template #default="{ row }">
            <el-button type="primary" @click="selectAccount(row)">
              선택
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="accountDialogVisible = false">닫기</el-button>
      </template>
    </el-dialog>


     <!-- 거래처 추가 모달 -->
    <supplier-add-modal
      v-model="isSupplierAddModalVisible"
      @close="closeSupplierAddModal"
    />
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { useCodeStore } from '@/stores/codeStore'; // Pinia 상태 관리 (예제)
  import SupplierAddModal from "./SupplierAddModal.vue";
  import axiosInstance from "@/api/axios";
  const dialogWidth = ref("50%");

  const isMobile = ref(window.innerWidth < 768);
  window.addEventListener("resize", () => {
    isMobile.value = window.innerWidth < 768;
  });

  const emits = defineEmits(['close', 'select']);
  const codeStore = useCodeStore();

  const dialogVisible = ref(true);
  const searchQuery = ref('');
  const filteredSuppliers = ref([]); // 필터된 공급사 데이터
  const isSupplierAddModalVisible = ref(false);
  const accountDialogVisible = ref(false); // 계좌 다이얼로그
  const selectedSupplier = ref(null); // Selected supplier

  const selectedSupplierAccounts = ref([]); // 선택된 공급사의 계좌 정보

  // 거래처 추가 모달 열기
const openSupplierAddModal = () => {
  alert('관리자에게 문의하세요')
  //isSupplierAddModalVisible.value = true;
};

// 거래처 추가 모달 닫기
const closeSupplierAddModal = () => {
  isSupplierAddModalVisible.value = false;
  console.log(" closeSupplierAddModal")
};

  // 거래처 데이터 로드
  const loadSuppliers = async () => {
    await codeStore.fetchSuppliers(); // API 호출 또는 Pinia 상태에서 가져오기
    filteredSuppliers.value = codeStore.suppliers;

  };
  
  // 검색 필터
  const filterSuppliers = () => {
    filteredSuppliers.value = codeStore.suppliers.filter((supplier) =>
      supplier.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
  };
  
  // 선택된 공급사의 계좌 보기
const showAccounts = async (supplier) => {
  selectedSupplier.value = supplier; // Set the selected supplier

  
  console.log("showAccounts" ,supplier )
  selectedSupplierAccounts.value = await fetchAccounts(supplier.supplier_id);
  accountDialogVisible.value = true;
};

  // 서버에서 계좌 리스트 조회
  const fetchAccounts = async (supplier_id) => {
  try {
    const response = await axiosInstance.get(`/suppliers/${supplier_id}/accounts/`);
    return response.data.results; // 서버에서 받아온 데이터를 로컬 상태에 저장    

  } catch (error) {
    console.error("서버에서 계좌 데이터를 가져오는 중 오류 발생:", error);
    alert("계좌 데이터를 가져오는 중 오류가 발생했습니다.");
  }
};

  // 계좌 선택 처리
const selectAccount = (account) => {
  console.log("선택된 계좌:", account);

  emits("select", selectedSupplier.value, account); // Emit supplier and account
  accountDialogVisible.value = false; // 계좌 선택 후 계좌 모달 닫기
  dialogVisible.value = false; // Close main modal


};


  // 모달 닫기 처리
const handleClose = () => {
    console.log("모달이 닫혔습니다.");
    emits('close'); // 부모로 visible 상태 전달    
};



  // 컴포넌트 마운트 시 거래처 데이터 로드
  onMounted(() => {
    loadSuppliers();

    if (window.innerWidth < 768) {
      dialogWidth.value = "90%"; // 📱 모바일에서는 다이얼로그 너비를 90%로 조정
    }
  });


  </script>
 <style scoped>

.full-width-button {
    width: 100%;
    font-size: 16px;
    padding: 12px 0;
    margin-bottom: 10px;
  }

  
</style>